enum GroupMigrationStatus {
    Created = 0,
    InProgress = 1,
    Complete = 2,
    Error = 3,
}

export default GroupMigrationStatus;
